const currentscreen = (state = [], action) => {
    switch (action.type) {
      case 'CURRENTSCREEN':
      localStorage.setItem('tela_atual_ingweb', action.screen)
      return {
          type: "CURRENTSCREEN",
          screen: action.screen,
          id: action.id,
          notifier: action.notifier,
          previous: action.previous,
        }
      default:
        return state
    }
  }
  
  export default currentscreen